import {createRouter, createWebHistory, RouteRecordRaw} from "vue-router";
import InstallmentsView from "@/views/InstallmentsView.vue";
import PaymentProvidersView from "@/views/PaymentProvidersView.vue";
import {trackRouter} from "vue-gtag-next";
import {getInstallments} from "@/services/DataService";
import {datadogRum} from "@datadog/browser-rum";
import packageJson from "@/../package.json";
import {store} from "@/store";
import OtherAmountView from "@/views/OtherAmountView.vue";
import SuperPacmanInstallmentsView from "@/views/SuperPacmanInstallmentsView.vue";
import {Countries} from "@/types/Countries";
import PaymentSuccessView from "@/views/PaymentSuccessView.vue";
import PaymentFailedView from "@/views/PaymentFailedView.vue";

const sampleRate = process.env.VUE_APP_K8_ENVIRONMENT_NAME === 'staging' ? 100 : 3;
const sessionReplayRate = process.env.VUE_APP_K8_ENVIRONMENT_NAME === 'staging' ? 50 : 5;

const initializeDatadogRum = (country: string | undefined) => {
    if (country === Countries.MEXICO && !datadogRum.getInitConfiguration()) {
        console.log("Initializing Datadog RUM");
        datadogRum.init({
            applicationId: process.env.VUE_APP_DATADOG_APPLICATION_ID as string,
            clientToken: process.env.VUE_APP_DATADOG_CLIENT_TOKEN as string,
            site: 'datadoghq.com',
            service: 'payoptions',
            env: process.env.VUE_APP_K8_ENVIRONMENT_NAME as string,
            version: packageJson.version,
            sessionSampleRate: sampleRate,
            sessionReplaySampleRate: sessionReplayRate,
            trackUserInteractions: true,
            trackResources: true,
            trackLongTasks: true,
            defaultPrivacyLevel: 'mask-user-input'
        });
        console.log("Datadog RUM initialized successfully");
    }
};

const fetchInstallmentsData = async (deviceTag: string, option: string) => {
    const {installments, error} = await getInstallments({deviceTag, paymentOption: option});
    store.dispatch("payOptions/setInstallments", installments);

    if (error.value) {
        store.dispatch("payOptions/setError", error.value)
        throw new Error("Failed to fetch installments");
    }
    console.log("Installments data fetched successfully");
};

const routes: Array<RouteRecordRaw> = [
    {
        path: "/",
        name: "root",
        component: () => import("@/components/HelloI18n.vue"),
        props: true,
    },
    {
        path: "/version",
        name: "Version",
        component: () => import("@/components/HelloI18n.vue"),
    },
    {
        path: "/device/:deviceTag",
        name: "InstallmentsByDevice",
        component: InstallmentsView,
        props: true,
        // beforeEnter: async (to, from, next) => {
        //     try {
        //         const option = await store.dispatch("payOptions/determineOption", to.params.showoptions as string | undefined);
        //         await fetchInstallmentsData(to.params.deviceTag as string, option);
        //         const country = authHelper.getSession()?.country;
        //         store.dispatch("payOptions/setCountry", country);
        //         initializeDatadogRum(country);
        //         next();
        //     } catch (error) {
        //         if (from.path === "/") {
        //             next()
        //         }
        //         console.error("Authentication or data fetching failed:", error);
        //         next(false);
        //     }
        // },
    },
    {
        path: "/providers/",
        name: "ProvidersByDeviceTagAndCountry",
        component: PaymentProvidersView,
        props: true,
    },
    {
        path: "/views/:providerName",
        name: "DynamicProviderLoader",
        component: () => import("@/views/DynamicProviderLoaderView.vue"),
    },
  {
      path: "/other-amount",
      name: "OtherAmountView",
      component: OtherAmountView
  },
  {
      path: "/p/device/:deviceTag",
      name: "SuperPacmanInstallments",
      component: SuperPacmanInstallmentsView,
  },
  {
      path: "/payment-success",
      name: "PaymentSuccessView",
      component: PaymentSuccessView,
  },
  {
      path: "/payment-failed",
      name: "PaymentFailedView",
      component: PaymentFailedView,
  },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

trackRouter(router);

export default router;
